// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__21MiN","productName":"Table_productName__2ZAtz"};